import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/_core/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-auth-unauthorized',
  templateUrl: './auth-unauthorized.component.html',
  styleUrls: ['./auth-unauthorized.component.scss']
})
export class AuthUnauthorizedComponent implements OnInit {

  loginUrl: string = environment.atsSsoUrl + "?returl=" + environment.clientAppUrl + '/auth-return';

  constructor(
    private authorize: AuthService,
  ) { }

  ngOnInit(): void {

  }

  login() {
    window.location.href = this.loginUrl;
  }

}
